// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BlackListedFileDialog__dialogTitle___2M8wv h2{color:#2c2c2c!important}", ""]);
// Exports
exports.locals = {
	"dialogTitle": "BlackListedFileDialog__dialogTitle___2M8wv"
};
module.exports = exports;
